import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

const bubbles = [
  { left: '6%', size: 12, delay: '0s', duration: '16s' },
  { left: '18%', size: 8, delay: '2s', duration: '19s' },
  { left: '28%', size: 14, delay: '4s', duration: '14s' },
  { left: '42%', size: 10, delay: '1s', duration: '18s' },
  { left: '55%', size: 18, delay: '3s', duration: '21s' },
  { left: '68%', size: 9, delay: '5s', duration: '17s' },
  { left: '78%', size: 11, delay: '2.5s', duration: '15s' },
  { left: '88%', size: 7, delay: '6s', duration: '20s' },
  { left: '94%', size: 13, delay: '1.5s', duration: '22s' },
];

function Layout() {
  return (
    <div className="min-h-screen w-full text-slate-900 flex flex-col relative">
      <div
        className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
        aria-hidden
      >
        {/* Sun / lens bloom */}
        <div className="absolute -top-16 left-1/2 h-[min(52vw,420px)] w-[min(95vw,900px)] -translate-x-1/2 rounded-full bg-gradient-to-b from-white/90 via-sky-100/50 to-transparent blur-2xl opacity-90 animate-aero-pulse-glow" />
        <div className="absolute top-[2%] left-1/2 h-24 w-24 -translate-x-1/2 rounded-full bg-white/80 blur-md shadow-[0_0_60px_rgba(255,255,255,0.9)]" />

        {/* Clouds — soft Vista-style puffs */}
        <div className="absolute top-[8%] left-[3%] h-16 w-44 rounded-full bg-white/75 blur-sm shadow-lg shadow-white/30 animate-aero-drift opacity-90" />
        <div className="absolute top-[10%] left-[8%] h-12 w-32 rounded-full bg-white/65 blur-sm animate-aero-drift opacity-80 [animation-delay:-8s]" />
        <div className="absolute top-[14%] right-[5%] h-20 w-56 rounded-full bg-white/70 blur-sm shadow-md shadow-sky-200/40 animate-aero-drift-slow opacity-85" />
        <div className="absolute top-[18%] right-[12%] h-14 w-36 rounded-full bg-white/60 blur-sm animate-aero-drift-slow opacity-75 [animation-delay:-12s]" />
        <div className="absolute top-[22%] left-[35%] h-10 w-28 rounded-full bg-white/50 blur-md animate-aero-drift opacity-70" />

        {/* Ambient orbs */}
        <div className="absolute -top-24 left-[12%] h-[380px] w-[480px] rounded-full bg-sky-200/50 blur-[80px] animate-aero-float" />
        <div className="absolute top-[28%] right-[-8%] h-[420px] w-[520px] rounded-full bg-cyan-200/40 blur-[90px] animate-aero-float [animation-delay:-3s]" />
        <div className="absolute bottom-[-5%] left-[20%] h-[320px] w-[640px] rounded-full bg-emerald-300/25 blur-[100px]" />

        {/* Rising glass bubbles */}
        {bubbles.map((b, i) => (
          <div
            key={i}
            className="absolute bottom-0 animate-aero-bubble-rise rounded-full border border-white/50 bg-gradient-to-br from-white/50 to-sky-300/25 shadow-aero-bubble"
            style={{
              left: b.left,
              width: b.size,
              height: b.size,
              animationDuration: b.duration,
              animationDelay: b.delay,
            }}
          />
        ))}

        {/* Horizon haze + meadow strip */}
        <div className="absolute inset-x-0 bottom-0 h-[28vh] bg-gradient-to-t from-emerald-900/50 via-emerald-600/15 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-[12vh] bg-gradient-to-t from-[#1a5c22]/90 via-[#2d8a38]/55 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-sky-950/25 via-transparent to-transparent" />
      </div>
      <div className="relative z-10 flex flex-col flex-grow w-full">
        <Navbar />
        <main className="flex-grow w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-3 pb-10 sm:pt-4 sm:pb-12">
          <Outlet />
        </main>
        <footer className="glass-card frutiger-nav backdrop-blur-xl py-10 mx-4 mb-6 sm:mx-6 max-w-7xl lg:mx-auto rounded-2xl border-aero-border shadow-frutiger-card">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <p className="text-slate-800/90 font-light font-display tracking-wide">
              &copy; 2026 Daniel Kuzmin
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Layout;
